module.exports = __webpack_public_path__ + "static/media/her2.f4461a72.jpg";